<template>
  <q-page class="column" v-if="item">
    <iframe :src="publicNoteSrc" style="width: 100%; height: 100%;" class="col" frameBorder="0"></iframe>
  </q-page>
</template>

<script>
import 'ace-builds/src-noconflict/mode-markdown'
import 'ace-builds/src-noconflict/mode-json'
import 'ace-builds/src-noconflict/theme-monokai'
import 'ace-builds/src-noconflict/ext-searchbox'
import 'ace-builds/src-noconflict/ext-spellcheck'

import Split from 'split.js'
import { updateCustomMd, resetCustomMd } from '../js/customMdParse/customMdParse'
// import { ComponentDefinition } from '../js/customMdParse/ComponentDefinition'
import { updateComponentHtmlInDOM } from '../js/customMdParse/components'
// import { findNoteHelper } from 'src/js/noteTemplates/noteHelpers'
import firestore from '../store/firestore'

function isInFullScreen () {
  return (document.fullscreenElement && document.fullscreenElement !== null) ||
    (document.webkitFullscreenElement && document.webkitFullscreenElement !== null) ||
    (document.mozFullScreenElement && document.mozFullScreenElement !== null) ||
    (document.msFullscreenElement && document.msFullscreenElement !== null)
}

function requestFullScreen (element) {
  if (isInFullScreen()) return
  var docElm = document.documentElement
  if (docElm.requestFullscreen) {
    docElm.requestFullscreen()
  } else if (docElm.mozRequestFullScreen) {
    docElm.mozRequestFullScreen()
  } else if (docElm.webkitRequestFullScreen) {
    docElm.webkitRequestFullScreen()
  } else if (docElm.msRequestFullscreen) {
    docElm.msRequestFullscreen()
  }
}

function exitFullScreen () {
  if (!isInFullScreen()) return
  if (document.exitFullscreen) {
    document.exitFullscreen()
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen()
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen()
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen()
  }
}

export default {
  data () {
    return {
      layoutOrientation: 'horizontal',
      updatingNote: false,
      item: null,
      noteHelper: null,
      renderedMd: '',
      splits: {
        userdata: { visible: false, index: 0, icon: 'mdi-code-braces', locked: false, name: 'User Data', content: 'editor' },
        data: { visible: false, index: 1, icon: 'mdi-markdown', locked: false, name: 'Data', content: 'editor' },
        preview: { visible: true, index: 2, icon: 'far fa-newspaper', locked: false, name: 'Preview', content: 'preview' }
      },
      splitter: null,
      maxEditors: 3,
      editorConfig: {}
    }
  },
  components: {
  },
  computed: {
    publicNoteSrc () {
      // return 'https://public.submind.io/notes/' + this.$route.params.id
      // return 'http://localhost:8081/notes/' + this.$route.params.id
      return (process.env.PUBLIC_URL || 'https://public.submind.io') + '/notes/' + this.$route.params.id
    },
    defaultEditorSettings () {
      // @see https://github.com/ajaxorg/ace/wiki/Configuring-Ace
      let editorSettings = this.$store.state.auth.currentUser.settings.editor
      let defaultOpts = {
        navigateWithinSoftTabs: true,
        animatedScroll: true,
        showInvisibles: false,
        printMargin: false,
        fontSize: '10px',
        // fontFamily: '',
        scrollPastEnd: 0.25,
        // theme: '',
        overwrite: false,
        newLineMode: 'auto', // "auto" | "unix" | "windows"
        useSoftTabs: true,
        useWorker: false,
        tabSize: 2,
        wrap: 'free',
        foldStyle: 'markbegin', // "markbegin"|"markbeginend"|"manual"
        readOnly: true
      }
      if (this.$store.state.auth.currentUser == null) return defaultOpts
      if (this.$store.state.auth.currentUser.settings == null) return defaultOpts
      if (this.$store.state.auth.currentUser.settings.editor == null) return defaultOpts
      return Object.assign(defaultOpts, editorSettings)
    },
    componentDefinitionAry () {
      let retAry = []
      // let allRawCmpDefs = Object.values(this.$store.state.components.components) // eslint-disable-line no-unused-vars
      // let enRawCmpDefs = this.$_.without(this.$_.map(this.$store.state.components.components, v => {
      //   return v.enabled ? v : null
      // }), null)
      // resetCustomMd()
      // enRawCmpDefs.forEach(rawCompDef => {
      //   retAry.push(new ComponentDefinition(
      //     rawCompDef.id,
      //     rawCompDef.name,
      //     rawCompDef.code.md,
      //     rawCompDef.code.css,
      //     rawCompDef.code.html,
      //     rawCompDef.code.js,
      //     rawCompDef.code.scripts
      //   ))
      // })
      // console.log('generate new component definition ary')
      return retAry
    },
    distractionFreeMode: {
      get () {
        return this.$store.state.ui.distractionFreeMode
      },
      set (v) {
        this.$store.commit('setDistractionFreeMode', v)
      }
    },
    userDataAsText () {
      return JSON.stringify(this.item.userData, null, 2)
    }
  },
  methods: {
    scrollHandler (editor, y) {
      if (editor !== 'data') return
      let aceEditor = this.$refs['cm' + editor][0].editor
      let aceHeight = aceEditor.session.getScreenLength() * aceEditor.renderer.lineHeight
      let contentScroller = this.$refs['contentScroller'][0]
      let contentScrollerHeight = contentScroller.scrollHeight
      contentScroller.setScrollPosition(y / aceHeight * contentScrollerHeight)
    },
    cmOpts (editor) {
      let editorSettings = Object.assign({}, this.defaultEditorSettings)
      switch (editor) {
        case 'data':
          editorSettings.spellcheck = true
          editorSettings.mode = 'markdown'
          break
        case 'userdata':
          editorSettings.spellcheck = true
          editorSettings.mode = 'json'
          break
      }
      return editorSettings
    },
    cmContent (editor) {
      if (editor === 'data') {
        return this.item.data
      } else if (editor === 'userdata') {
        return this.userDataAsText
      }
    },
    getCustomButtonVm (btn) {
      let vm = btn.vm
      if (!vm) {
        // vm = this.noteHelper.noteTemplateInst
        vm = this
      } else if (vm === 'template') {
        vm = this.noteHelper.noteTemplateInst
      } else if (vm === 'editor') {
        vm = this
      }
      return vm
    },
    customButtonIcon (btn) {
      if (typeof btn.icon === 'function') {
        let vm = this.getCustomButtonVm(btn)
        return btn.icon.bind(vm).call()
      } else if (typeof btn.icon === 'string') {
        return btn.icon
      }
    },
    customButtonClick (btn) {
      let vm = this.getCustomButtonVm(btn)
      if (typeof btn.callback === 'function') {
        btn.callback.bind(vm).call()
      } else if (typeof btn.callback === 'string') {
        vm[btn.callback].bind(vm).call()
      }
    },
    render () {
      if (this.$store.state.ui.skipMdRender) {
        console.log('skiprender')
        this.$store.commit('setSkipMdRender', false)
        return this.renderedMd
      }
      console.log('rendered!!')
      let curPos = null
      // if (this.codemirror() && this.codemirror().hasFocus() && !this.$q.platform.is.mobile) {
      //   curPos = this.codemirror().indexFromPos(this.codemirror().getCursor())
      // }
      this.renderedMd = updateCustomMd(this.item.data || '', this.componentDefinitionAry, this.item, curPos, false, this.saveThrottled) // eslint-disable-line vue/no-side-effects-in-computed-properties
      updateComponentHtmlInDOM()
    },
    switchOrientation () {
      if (this.layoutOrientation === 'horizontal') {
        this.layoutOrientation = 'vertical'
      } else {
        this.layoutOrientation = 'horizontal'
      }
      this.recreateSplits()
    },
    showEditorSettings () {
      this.$store.dispatch('openSettingsDialog', 'editor')
    },
    toggleDistractionFreeMode (fullscreen) {
      this.distractionFreeMode = !this.distractionFreeMode
      if (fullscreen) {
        requestFullScreen()
      } else {
        exitFullScreen()
      }
    },
    openInPopup () {
      window.open(window.location.href, '_blank', 'menubar=no,statusbar=no')
    },
    configureEditor (config) {
      // Standard layout
      this.editorConfig = config
      this.splits = config.splits

      this.$nextTick(() => {
        this.recreateSplits(false)
        this.render()
      })
    },
    pullRemoteComponent (id) {
      let t = this
      t.updatingNote = true

      console.log(firestore)
      console.log(firestore.db)
      window.fs = firestore
      let docRef = firestore.db.collection('publicNotes').doc(id)

      return docRef.get().then((doc) => {
        if (doc.exists) {
          resetCustomMd()
          // t.configureEditor(config)
          t.item = { id: doc.id, ...doc.data() }
          this.render()
        } else {
          throw new Error('Public note does not exist.')
        }
        t.updatingNote = false
      }).catch(ex => {
        t.$router.replace('/home')
        console.warn(ex)
        console.warn('Error pulling item ' + id + 'from store.')
        t.updatingNote = false
      })
    },
    checkZeroWidthSplits () {
      let needsUpdate = false
      let sizes = this.splitter.getSizes()
      let openSplits = this.$_.sortBy(this.$_.without(this.$_.map(this.splits, (v, k) => { return v.visible ? v : null }), null), 'index')
      sizes.forEach((s, i) => {
        if (s < 1) {
          openSplits[i].visible = false
          needsUpdate = true
        }
      })
      if (needsUpdate) this.recreateSplits()
    },
    refreshVisibleEditors () {
      this.$_.without(this.$_.map(this.splits, (v, k) => { return v.visible ? 'cm' + k : null }), null).forEach(en => {
        if (en === 'cmpreview') return
        this.updateEditorWrapping(en)
      })
    },
    updateEditorWrapping (editorName) {
      if (!(editorName in this.$refs)) return
      this.$refs[editorName][0].updateEditorWrapping()
    },
    recreateSplits (preserveWidths) {
      let selectors = this.$_.without(this.$_.map(this.splits, (v, k) => { return v.visible ? '#cm' + k + 'div' : null }), null)
      let widths = null

      if (preserveWidths && this.splitter) {
        widths = this.splitter.getSizes()
      }

      if (this.splitter) {
        this.splitter.destroy()
      }

      let t = this
      this.splitter = Split(selectors, {
        sizes: widths,
        minSize: 0,
        gutterSize: 8,
        direction: this.layoutOrientation,
        onDragEnd: function () {
          // localStorage.setItem('split-sizes', JSON.stringify(split.getSizes()));
          t.checkZeroWidthSplits()
          t.refreshVisibleEditors()
        },
        elementStyle: function (dimension, size, gutterSize) {
          return {
            'flex-basis': 'calc(' + size + '% - ' + gutterSize + 'px)'
          }
        },
        gutterStyle: function (dimension, gutterSize) {
          return {
            'flex-basis': gutterSize + 'px'
          }
        }
      })
      this.$nextTick(() => {
        t.refreshVisibleEditors()
      })
    },
    visibleSplits () {
      return this.$_.countBy(this.splits, 'visible')[true]
    },
    visibleUnlockedSplits () {
      return this.$_.pickBy(this.splits, s => s.visible && !s.locked)
    },
    closeExtraSplits (aboutToOpen) {
      while (this.visibleSplits() + (aboutToOpen ? 1 : 0) > this.maxEditors) { // eslint-disable-line no-unmodified-loop-condition
        this.splits[Object.keys(this.visibleUnlockedSplits())[0]].visible = false
        // this.splits[this.$_.findKey(this.splits, ['visible', true])].visible = false
      }
    },
    clickSetSplit (split) {
      if (!split.visible) {
        if (Object.keys(this.visibleUnlockedSplits()).length + 1 <= this.maxEditors) {
          this.setSplitVisible(split, 'true')
        }
      // } else if (split.visible && !split.locked) {
      //   split.locked = true
      } else {
        split.locked = false
        this.setSplitVisible(split, false)
      }
    },
    setSplitVisible (split, visible) {
      if (visible === 'toggle') visible = !split.visible
      let preserveWidths = false
      let openSplits = this.visibleSplits()
      // Not allowed to turn all splits off.  Must keep at least one!
      if (openSplits === 1 && !visible) return
      this.closeExtraSplits(visible)
      split.visible = visible
      if (this.visibleSplits() === openSplits) preserveWidths = true // Same number of splits?
      this.recreateSplits(preserveWidths)
    },
    insertImage () {
      let t = this
      this.$refs.uploader.show(this.item.id).then((fileName) => {
        let text = '!img(' + fileName + ')'

        let cursor = t.$refs['cmdata']._data.codemirror.getDoc().getCursor()
        t.$refs['cmdata']._data.codemirror.replaceRange(text, cursor)
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.pullRemoteComponent(vm.$route.params.id)
    })
  },
  beforeRouteLeave (to, from, next) {
    next()
  },
  beforeRouteUpdate (to, from, next) {
    this.pullRemoteNote(to.params.id).then(() => {
      if (this.$refs['cmdata'][0]) {
        this.$refs['cmdata'][0].setValue(this.item.data)
      }
      if (this.$refs['cmuserdata'][0]) {
        this.$refs['cmuserdata'][0].setValue(this.userDataAsText)
      }
    })
    next()
  }
}
</script>

<style lang="styl">
  .allow-touch .q-touch {
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
  }
</style>
